import styled from "styled-components";
import ScrollAnimation from "react-animate-on-scroll";

import { scrollAnimationProps as animationProps } from "globalConstants";

import * as Types from "Types";

import AtomH1 from "Components/Atoms/H1";
import * as images from "images";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
   max-width: 1200px;
   margin-top: 115px;
   & .animated {
      transition-duration: 1s;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      opacity: 0;
   }
   & .scrollAnimation {
      opacity: 1;
   }
   ${({ css }) => css}
`;

const LogoSection = styled.div`
   margin-top: 90px;
`;

export default function SectionPartners(props: Types.Default) {
   return (
      <Wrap {...props}>
         <ScrollAnimation {...animationProps}>
            <AtomH1>아트맵은 든든한 파트너, 협력기관과 함께 합니다</AtomH1>
         </ScrollAnimation>
         <ScrollAnimation {...animationProps}>
            <LogoSection>
               <img src={images.logoSection} alt="" />
            </LogoSection>
         </ScrollAnimation>
      </Wrap>
   );
}
